<style lang="scss" scoped>
.product-container {
  .hideFormItem {
    display: none !important;
  }

  .form-container {
    margin-top: 15px;
  }

  .tag-container {
    margin-top: 35px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    // 左侧
    .left {
      display: flex;
      align-items: center;
      width: 280px;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419fff;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }
    }
  }

  .product-container {
    margin-top: 20px;
    width: 100%;
    min-height: 310px;
    margin-bottom: 50px;

    #productChart {
      width: 100%;
      height: 310px;
    }
  }

  .product-container2 {
    //margin-top: 20px;
    width: 100%;
    min-height: 310px;
    margin-bottom: 50px;

    #productChart2 {
      width: 100%;
      height: 310px;
    }
  }
}
</style>
<template>
  <div class="product-container">
    <div class="form-container">
      <el-form :style="{ height: screenWidth > 1232 ? '48px' : '' }" :model="conditions" :inline="true" size="mini">
        <el-form-item :label="$t('xuanzeriqi')">
          <yi_time_input type="datetimerange" :maxTime="365 * 24 * 3600 * 1000" :start.sync="conditions.reportDateStart" :end.sync="conditions.reportDateEnd"> </yi_time_input>
        </el-form-item>
        <el-form-item :label="$t('suoshuzuzhi')">
          <yi_data_select :type="'organization'" :ids.sync="conditions.orgIdSelected" :idsPath.sync="conditions.orgId"></yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('shebeimingcheng')">
          <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="conditions.equipmentId"> </yi_data_select>
          <!--          <yi_cross_select multiple :component="'web_base_equipment_list'"-->
          <!--              :ids.sync="conditions.equipmentId">-->
          <!--          </yi_cross_select>-->
        </el-form-item>
        <el-form-item :label="$t('chanpinmingcheng')">
          <yi_data_select :width="'250px'" :multiple="true" :max="3" :type="'material2'" :ids.sync="conditions.materialId"> </yi_data_select>
          <!--          <yi_cross_select multiple :max="3" :component="'web_base_matter_list'" :ids.sync="conditions.materialId">-->
          <!--          </yi_cross_select>-->
        </el-form-item>
        <el-form-item>
          <el-button @click="getManufacturing(false)" type="primary" plain="plain">
            {{ $t("sousuo") }}
          </el-button>
          <el-button @click="reset">{{ $t("chongzhi") }} </el-button>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tag-container">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t("chanpinchanliangpaiming") }}</span>
      </div>
    </div>
    <div class="product-container" :key="key">
      <div v-loading="searchLoading" id="productChart"></div>
    </div>

    <div class="tag-container">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t("meitianchanpinchanliangqushi") }}</span>
        <span>{{ $t("(qingzaishangfangxuanzechanpin)") }}</span>
      </div>
    </div>
    <div>
      <div v-if="conditions.materialId" class="product-container2" :key="key">
        <div v-loading="searchLoading2" id="productChart2"></div>
      </div>
      <div v-else style="display: flex;justify-content: center;align-items: center">
        <el-empty></el-empty>
      </div>
    </div>
    <!--  <div>-->
    <!--    <el-empty description="描述文字"></el-empty>-->
    <!--  </div>-->
  </div>
</template>

<script>
export default {
  name: "web_report_equipment_capacity_statistics_production_statistics_product",
  props: {
    parentParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      screenWidth: "", // 可视窗口的宽度
      searchLoading: false,
      searchLoading2: false,
      key: 0,
      productCharts: null,
      manufacturing: [],
      manufacturings: [],
      conditions: {},
      productRankingCharts: null,
    };
  },
  watch: {
    parentParams: {
      handler(n) {
        if (n.orgId) {
          this.$set(this.conditions, "orgIdSelected", n.orgId);
        }
        if (n.firstDate) {
          this.$set(this.conditions, "reportDateStart", new Date(n.firstDate).getTime());
        }
        if (n.lastDate) {
          this.$set(this.conditions, "reportDateEnd", new Date(n.lastDate).getTime());
        }
        setTimeout(() => {
          this.getManufacturing(true);
        }, 0);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("PRODUCTION_STATISTICS_RESIZE", () => {
      this.resize();
    });
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        this.screenWidth = document.body.clientWidth;
        if (this.productCharts != null) {
          this.productCharts.resize();
        }
        if (this.productRankingCharts != null) {
          this.productRankingCharts.resize();
        }
      }, 500);
    },
    reset() {
      if (this.parentParams.selectedOrgIds !== undefined) {
        this.$set(this.conditions, "materialId", undefined);
        this.$set(this.conditions, "equipmentId", undefined);
        this.$set(this.conditions, "reportDateStart", new Date(this.parentParams.firstDate).getTime());
        this.$set(this.conditions, "reportDateEnd", new Date(this.parentParams.lastDate).getTime());
        this.$set(this.conditions, "orgId", this.parentParams.selectedOrgIds + "");
        this.$set(this.conditions, "orgIdSelected", this.parentParams.orgId);
        this.getProduct();
        this.getManufacturing();
      }
      if (this.conditions.orgId !== undefined && this.parentParams.selectedOrgIds == undefined) {
        this.conditions.reportDateStart = undefined;
        this.conditions.reportDateEnd = undefined;
        this.conditions.orgId = undefined;
        this.conditions.orgIdSelected = undefined;
        this.conditions.materialId = undefined;
        this.conditions.equipmentId = undefined;
        ++this.key;
      }
    },
    mapSeries(obj) {
      let xAxis = [];
      for (const i in obj) {
        const arr = obj[i];
        const result = arr.reduce((acc, cur) => {
          if (!acc[cur.time]) {
            acc[cur.time] = { time: cur.time, date: cur.date, badQuantitySum: cur.badQuantitySum };
          } else {
            acc[cur.time].badQuantitySum += cur.badQuantitySum;
          }
          return acc;
        }, {});
        obj[i] = Object.values(result);
      }
      if (Object.keys(obj).length > 1) {
        const dates = Array.from(new Set([].concat(...Object.values(obj).map((item) => item.map((subItem) => subItem.time)))));
        // 将不存在的日期添加到班次中，并将 num 值设为 0
        Object.values(obj).forEach((item) => {
          dates.forEach((date) => {
            if (!item.some((subItem) => subItem.time === date)) {
              item.push({ time: date, badQuantitySum: 0 });
            }
          });
        });
        // 对班次中的日期按时间排序
        Object.values(obj).forEach((item) => item.sort((a, b) => a.time.localeCompare(b.time)));
      }
      for (const i in obj) {
        xAxis = obj[i].map((item) => {
          return item.time;
        });
      }
      for (const i in obj) {
        obj[i] = obj[i].map((item) => {
          return item.badQuantitySum;
        });
      }
      const orderedObj = {};
      Object.keys(obj)
        .sort()
        .forEach((key) => {
          orderedObj[key] = obj[key];
        });
      return {
        xAxis: xAxis,
        seriesData: orderedObj,
      };
    },
    //产品产量排名
    getManufacturing(init) {
      if(this.conditions.materialId){
      this.getProduct()
      }
      if (init && !this.conditions.reportDateStart) {
        return false;
      }
      this.searchLoading = true;
      let requestParam = {
        ...this.conditions,
        orderBy: "badQuantitySum desc",
      };
      if (Array.isArray(requestParam["equipmentId"]) && requestParam["equipmentId"].length > 0) {
        requestParam["equipmentId"] = requestParam["equipmentId"].join(",");
      }
      if (Array.isArray(requestParam["materialId"]) && requestParam["materialId"].length > 0) {
        requestParam["materialId"] = requestParam["materialId"].join(",");
      }
      if (Array.isArray(requestParam["orgId"]) && requestParam["orgId"].length > 0) {
        requestParam["orgId"] = requestParam["orgId"].join(",");
      }
      return this.http
        .get("/web/report/page/manufacturing_statistics_material?pageSize=10&" + this.qs.stringify(requestParam))
        .then((response) => {
          this.manufacturings = response.data.rows;
          this.drawTableChart(response.data.rows);
          this.searchLoading = false;
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.searchLoading = false;
        });

    },
    //每天产品产量趋势
    getProduct() {
      this.searchLoading2 = true;
      let requestParam = {
        ...this.conditions,
        orderBy: "reportDate asc",
      };
      delete requestParam.orgIdSelected;
      if (Array.isArray(requestParam["equipmentId"]) && requestParam["equipmentId"].length > 0) {
        requestParam["equipmentId"] = requestParam["equipmentId"].join(",");
      }
      if (Array.isArray(requestParam["materialId"]) && requestParam["materialId"].length > 0) {
        requestParam["materialId"] = requestParam["materialId"].join(",");
      }
      if (Array.isArray(requestParam["orgId"]) && requestParam["orgId"].length > 0) {
        requestParam["orgId"] = requestParam["orgId"].join(",");
      }
      return this.http
        .get("/web/report/page/manufacturing_statistics_material_and_day?" + this.qs.stringify(requestParam))
        .then((response) => {
          this.manufacturing = response.data.rows;
          const obj = {};
          if (response.data.rows.length > 0) {
            for (let i = 0; i < response.data.rows.length; i++) {
              if (!obj.hasOwnProperty(response.data.rows[i]["materialName"])) {
                this.$set(obj, response.data.rows[i]["materialName"], {});
              }
            }
          }
          this.drawTableChart2(response.data.rows, obj);
          this.searchLoading2 = false;
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.searchLoading2 = false;
        });
    },
    //产品不良率
    drawTableChart(data = []) {
      this.productCharts = this.echarts.getInstanceByDom(document.getElementById("productChart"));
      if (this.productCharts == null) {
        this.productCharts = this.echarts.init(document.getElementById("productChart"));
      }
      let series = [];
      let xAxis = [];
      let chartData = {};
      console.log("1111", data);
      if (data.length > 0) {
        xAxis = data.map((item) => {
          return item["materialName"];
        });
        const originData = data.map((item) => {
          return item["badQuantitySum"];
        });
        series.push({
          name: "",
          type: "bar",
          barWidth: "12px",
          label: {
            normal: {
              show: true,
              position: "top",
              formatter: "{c}",
              color: "#43A0FF",
            },
          },
          itemStyle: {
            normal: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#419FFF",
                },
                {
                  offset: 1,
                  color: "rgba(227, 227, 227,0.3)",
                },
              ]),
              barBorderRadius: 6,
            },
          },
          data: originData,
          barGap: "80%",
          barCategoryGap: "100%",
        });
      }
      let option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "20",
          right: "20",
          bottom: "60",
          top: "16%",
          containLabel: true,
        },
        // legend: {
        //   left: 'center',
        //   top: '5%',
        //   textStyle: {
        //     color: '#000',
        //   },
        //   itemWidth: 12,
        //   itemHeight: 12,
        //   itemGap: 32,
        // },
        dataZoom: [
          {
            show: true,
            height: 18,
            xAxisIndex: [0],
            bottom: 20,
            start: 0,
            end: 100,
            handleIcon: "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
            handleSize: "100%",
            handleStyle: {
              color: "rgba(255, 255, 255,1)",
            },
            textStyle: {
              color: "#909399",
              fontSize: 12,
            },
            fillerColor: "#CBCED4",
            borderColor: "rgba(255, 255, 255,1)",
            backgroundColor: "#F0F2F5",
            showDataShadow: true,
            brushSelect: false,
          },
          {
            type: "inside",
            disabled: false,
          },
        ],
        xAxis: {
          show: true,
          type: "category",
          nameLocation: "end",
          nameTextStyle: {
            fontSize: 14,
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#000",
              width: 1,
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: "auto",
            inside: false,
            length: 5,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLabel: {
            interval: 0, // 间隔长度，可自定义（如果是时间格式，echarts会自动处理）
            rotate: 0, // 横坐标上label的倾斜度
            showMaxLabel: true, // 显示最大刻度
            showMinLabel: true, // 显示最小刻度
            hideOverlap: true, //隐藏互相遮挡的文本标签
            color: "#909399",
          },
          data: xAxis,
        },
        yAxis: {
          type: "value",
          data: [0, 20, 40, 60, 80, 100],
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: "{value}",
          },
          nameTextStyle: {
            color: "#909399",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "#e4e7ed",
            },
          },
        },
        series: series,
      };
      this.productCharts.setOption(option);
    },
    getRandomColor() {
      let str = "#";
      const arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
      for (let i = 0; i < 6; i++) {
        const num = parseInt(Math.random() * 16);
        str += arr[num];
      }
      return str;
    },
    drawTableChart2(data = []) {
      if (!document.getElementById("productChart2")) {
        return;
      }
      this.productRankingCharts = this.echarts.getInstanceByDom(document.getElementById("productChart2"));
      if (this.productRankingCharts == null) {
        this.productRankingCharts = this.echarts.init(document.getElementById("productChart2"));
      }
      // let firstData = [] // 早
      // let secondData = [] // 中
      // let thirdData = [] // 晚
      let series = [];
      let xAxis = [];
      let seriesData = {};
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (!seriesData[data[i]["materialName"]]) {
            seriesData[data[i]["materialName"]] = [];
          }
          const date = new Date(data[i]["reportDate"]);
          const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
          const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
          data[i]["time"] = month + "-" + day;
          data[i]["date"] = `${month}月${day}日`;
          seriesData[data[i]["materialName"]].push(data[i]);
        }
      }
      if (Object.keys(seriesData).length > 0) {
        const res = this.mapSeries(seriesData);
        xAxis = res.xAxis;
        seriesData = res.seriesData;
      }
      for (const i in seriesData) {
        series.push({
          name: i,
          type: "bar",
          barWidth: "12px",
          label: {
            normal: {
              show: false,
              position: "top",
              formatter: "{b}",
              color: "#43A0FF",
            },
          },
          itemStyle: {
            barBorderRadius: 6,
          },
          data: seriesData[i],
          barGap: "80%",
          barCategoryGap: "100%",
        });
      }
      let option2 = {
        // tooltip: {
        //   trigger: "item",
        //   formatter: (params) => {
        //     return params.marker + params.name + "<br/>" + params.seriesName + "：" + params.value + "<br/>";
        //   },
        // },
        grid: {
          left: "20",
          right: "20",
          bottom: "60",
          top: "16%",
          containLabel: true,
        },
        color: ["#419FFF", "#B09BFE", "#AB41FF"],
        legend: {
          left: "center",
          textStyle: {
            color: "#000",
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },
        dataZoom: [
          {
            show: true,
            height: 18,
            xAxisIndex: [0],
            bottom: 20,
            start: 0,
            end: 100,
            handleIcon: "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
            handleSize: "100%",
            handleStyle: {
              color: "rgba(255, 255, 255,1)",
            },
            textStyle: {
              color: "#909399",
              fontSize: 12,
            },
            fillerColor: "#CBCED4",
            borderColor: "rgba(255, 255, 255,1)",
            backgroundColor: "#F0F2F5",
            showDataShadow: true,
            brushSelect: false,
          },
          {
            type: "inside",
            disabled: false,
          },
        ],
        xAxis: {
          show: true,
          type: "category",
          nameLocation: "end",
          nameTextStyle: {
            fontSize: 14,
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#000",
              width: 1,
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: "auto",
            inside: false,
            length: 5,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLabel: {
            interval: 0, // 间隔长度，可自定义（如果是时间格式，echarts会自动处理）
            rotate: 0, // 横坐标上label的倾斜度
            showMaxLabel: true, // 显示最大刻度
            showMinLabel: true, // 显示最小刻度
            hideOverlap: true, //隐藏互相遮挡的文本标签
            color: "#909399",
          },
          data: xAxis,
        },
        yAxis: {
          type: "value",
          data: [0, 20, 40, 60, 80, 100],
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: "{value}",
          },
          nameTextStyle: {
            color: "#909399",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "#e4e7ed",
            },
          },
        },
        series: series,
      };
      this.productRankingCharts.setOption(option2);
    },
  },
};
</script>

<style scoped></style>
